import { useCallback } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { TValidationMethod } from 'js/utils/Validation/types';

import * as helpers from './helpers';
import { useGetFormFieldValue } from '../../../../hooks';
import { useWithRecordLevelValidation } from '../useWithRecordLevelValidation';

export const useIBANFieldValidation = ({ fieldName }: { fieldName: string }) => {
    const translate = useTranslations();
    const getFormFieldValue = useGetFormFieldValue();
    const withRecordLevelValidation = useWithRecordLevelValidation({ fieldName });

    const ibanValidate = useCallback<TValidationMethod<string>>(async (valueRaw) => {
        const value = valueRaw.trim();
        const countryCode = getFormFieldValue('countrycode');
        const error = translate('playtech.mobile.system.form.iban.internal.doubleCheck');

        if (!countryCode || !value || !/\d+/.test(value)) {
            return error;
        }

        const countryCodeNum = Array.from(countryCode)
            .map(char => char.charCodeAt(0) - 55)
            .join('');

        const ibanMod = value.substring(2) + countryCodeNum + value.substring(0, 2);

        return helpers.modulo(ibanMod, 97) === 1
            ? undefined
            : error;
    }, [getFormFieldValue, translate]);

    return withRecordLevelValidation(ibanValidate);
};
